import { httpClient } from '../httpClient';

export const dataflowProcessorApi = {
  listEntities: (params) =>
    httpClient.get('/dataflow/processors/entities', { params }),

  getEntity: (entityId) =>
    httpClient.get(`/dataflow/processors/entities/${entityId}`),

  createEntity: (data) =>
    httpClient.post('/dataflow/processors/entities', data),

  updateEntity: (entityId, data) =>
    httpClient.put(`/dataflow/processors/entities/${entityId}`, data),

  deleteEntity: (entityId) =>
    httpClient.delete(`/dataflow/processors/entities/${entityId}`),

  getChainTree: (flowId) =>
    httpClient.get(`/dataflow/processors/chains/${flowId}`),

  createChainLink: (data) =>
    httpClient.post('/dataflow/processors/chains/links', data),

  deleteChainLink: (linkId) =>
    httpClient.delete(`/dataflow/processors/chains/links/${linkId}`),

  triggerBreachCascade: (flowId, data) =>
    httpClient.post(`/dataflow/processors/chains/${flowId}/breach-cascade`, data),
};
